import React from 'react'
import './Skeleton.scss'

export type TPropsSkeleton = {
  height?: number
  width?: number
  style?: React.CSSProperties
}

function Skeleton({ height = 20, width = 100, style }: TPropsSkeleton) {
  return <div className="skeleton" style={{ height, width, ...style }} />
}

export default Skeleton
